import React from "react";
import type { LucideIcon } from "lucide-react";

type FeatureCardProps = {
  icon: LucideIcon | string;
  title: string;
  description: string;
  className?: string;
  id?: string;
};

export function FeatureCard({
  icon: Icon,
  title,
  description,
  className = "",
  id,
}: FeatureCardProps) {
  return (
    <div
      id={id}
      className={`flex flex-col sm:flex-row items-stretch overflow-hidden sm:rounded-lg sm:border sm:border-gray-50 bg-white -mx-4 md:mx-0 ${className}`}
    >
      <div className='flex sm:w-48 shrink-0 flex-col items-center justify-center gap-3 p-6 sm:p-10'>
        {typeof Icon === 'string' ? (
          <div className='flex h-12 w-12 items-center justify-center rounded-lg bg-gray-50'>
            <img src={Icon} alt={title} className='h-8 w-8 object-contain' />
          </div>
        ) : (
          <div className='flex h-12 w-12 items-center justify-center rounded-lg bg-gray-50 text-oh-black'>
            <Icon className='h-8 w-8' />
          </div>
        )}
        <div className='text-sm font-medium text-center text-oh-black'>{title}</div>
      </div>

      <div className='grid items-center bg-gray-50 p-4 sm:p-6 md:p-8 text-sm leading-5 text-oh-black'>
        <div dangerouslySetInnerHTML={{ __html: description as string }} className='text-justify' />
      </div>
    </div>
  );
}
